import React from 'react';
import Svg, { Rect } from '@dbk/ui-svg';
import { View } from '@dbk/ui-react-utils';

const MinusSign = ({fill = 'white', width=15, height= 15, style}) => (
  <View style={style}>
    <Svg width={width} height={height}>
      <Rect x="0" y="6" width={width} height="3" fill={fill} />
    </Svg>
  </View>
);

export default MinusSign;
